import { useEffect, useState, useRef } from 'react'
import './call-resume-pdf.scss'
import ComplianceHits from './ComplianceHits'
import ComplianceImprovents from './ComplianceImprovents'
import LoadingReport from './LoadingReport';
import CallStyles from './CallStyles'
import CallKPI from './CallKPI'
import { useTranslate } from '../../lib'

export default function CallReportResumePDF({ data, onLoadComplete }) {
  const [call, setCall] = useState(data);
  const [positive, setPositive] = useState(0)
  const [neutro, setNeutro] = useState(0)
  const [negative, setNegative] = useState(0)
  const [total, setTotal] = useState(0)
  const targetRef = useRef();
  const [listproofread, setListProofRead] = useState([])
  const [proofreadscore, setProofReadScore] = useState(0)
  const [loading, setLoading] = useState(true);
  const { t } = useTranslate();

  useEffect(() => {
    if (data) {
      setCall(data);
      let positive_count = 0;
      let negative_count = 0;
      let neutro_count = 0;
      let total_sum = 0;

      data.sentiment?.forEach(item => {
        if (item.polarity === 'POS') {
          positive_count += 1;
          total_sum += 1;
        } else if (item.polarity === 'NEU') {
          neutro_count += 1;
          total_sum += 0;
        } else if (item.polarity === 'NEG') {
          negative_count += 1;
          total_sum -= 1;
        }
      });

      setNegative(negative_count);
      setPositive(positive_count);
      setNeutro(neutro_count);

      const score = (total_sum / (data.sentiment?.length || 1));
      setTotal(((score + 1) / 2).toFixed(2));

      setListProofRead(data?.listproofread)
      if (data.listproofread.length) {
        setProofReadScore((data?.proofread * 100).toFixed(1));
      }
      setLoading(false);
      if (onLoadComplete) {
        onLoadComplete();
      }
    }
  }, [data, onLoadComplete]);

  if (loading) {
    return <LoadingReport />;
  }
  const getClass = (accuracy) => {
    return accuracy > 79 ? 'text-[#00d769]' : 'text-[#FF303E]';
  };
  return (
    <div ref={targetRef}>
      <div className="info-call-pdf w-full" style={{ backgroundColor: 'white' }}>
        <div className="info-call-item-pdf header-pdf">
          <div className="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <h4 style={{ fontWeight: "bold", color: "#0B5FA3", fontSize: 18 }}>{t('common.scoreMayus')}:</h4>
              <span class="porcentaje ml-3" style={{ color: '#0B5FA3', fontSize: 26, fontWeight: "bold" }}>
                {Number((call.qualification * 100).toFixed(1))}%
              </span>
            </div>
            <div className="d-flex flex-column align-items-center">
              <h4 style={{ fontWeight: "bold", color: "#0B5FA3", fontSize: 12 }}>{'ID: ' + call.id}</h4>
              <h4 style={{ fontWeight: "bold", color: "#0B5FA3", fontSize: 12 }}>{'NT USER: ' + call.ntUser}</h4>
            </div>
          </div>

          <div style={{ textTransform: 'uppercase', fontSize: 14, color: "#0B5FA3" }}>
            {/*<h4 style={{ fontSize: 18, fontWeight: "bold",color: "#0B5FA3" }}>Bot sentiment result:</h4>*/}
            <div class="d-flex flex-row align-items-center"
              style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
              <div class="m-1" style={{ fontWeight: "bold" }}>{t('reports.positive')}:</div>
              <div style={{ marginLeft: 3 }}>{positive}</div>
            </div>
            <div class="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <div style={{ fontWeight: "bold" }}>{t('reports.neutral')}:</div>
              <div style={{ marginLeft: 3 }}>{neutro}</div>
            </div>
            <div class="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <div style={{ fontWeight: "bold" }}>{t('reports.negative')}:</div>
              <div style={{ marginLeft: 3 }}>{negative}</div>
            </div>
            <div class="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <div class="m-1" style={{ fontWeight: "bold" }}>{t('reports.sentiment')}:</div>
              <div style={{ marginLeft: 3, letterSpacing: 1 }}>{total * 100}%</div>
            </div>
          </div>

          <div className="item-pdf">
            <div style={{ border: '2px solid #0B5FA3', width: 200 }} className='p-3'>
              <h4 className='font-bold text-[#0B5FA3] uppercase' style={{ fontSize: 13 }}>{t('reports.totalTimeCall')}</h4>
              <div className='text-[#0B5FA3] w-100 text-bold' style={{ textAlign: 'right', fontSize: 24 }}>
                {call.time_call}
              </div>
            </div>
            <div style={{ borderTop: '2px solid #0B5FA3', borderBottom: '2px solid #0B5FA3', width: 200 }} className='p-3'>
              <h4 className='font-bold text-[#0B5FA3] uppercase' style={{ fontSize: 13 }}>{t('reports.timesInHold')}</h4>
              <div className='text-[#0B5FA3] w-100 text-bold' style={{ textAlign: 'right', fontSize: 24 }}>
                {call?.time_hold || 0}
              </div>
            </div>
            <div style={{ border: '2px solid #0B5FA3', borderRight: '2px solid #0B5FA3', borderBottom: '2px solid #0B5FA3', width: 200 }} className='p-3'>
              <h4 className='font-bold text-[#0B5FA3] uppercase' style={{ fontSize: 13 }}>{t('reports.totalHoldTime')}</h4>
              <div className='text-[#0B5FA3] w-100 text-bold' style={{ textAlign: 'right', fontSize: 24 }}>
                {call?.second_hold || 0}
              </div>
            </div>
          </div>
        </div>

        {call.short_conversation == 1 &&
        <div class="info-call-item-pdf body-pdf">
            <h6 className="font-bold">
                {t('reports.shortConversation')}
            </h6>
        </div>}

        {call.short_conversation == 0 && 
        <div className="info-call-item-pdf body-pdf">
          <div>
            <h2 className="font-bold text-[#0B5FA3] text-[18px]" >{t('reports.hits')}</h2>
            <div className="container-call-info-no-scroll">
              <ComplianceHits data={call} />
            </div>
          </div>
          <div style={{ paddingRight: 15 }}>
            <h2 className="font-bold text-[#0B5FA3] text-[18px]" >{t('reports.improvements')}</h2>
            <div className="container-call-info-no-scroll">
              <ComplianceImprovents data={call} />
            </div>
          </div>
        </div>}
      </div>

      <div className="info-call-pdf w-full" style={{ backgroundColor: 'white', paddingTop: 10 }}>
        <div class="info-call-item-pdf header-pdf flex items-center w-full justify-center" style={{ padding: 15, backgroundColor: "white" }} >
          <div class="agents-pdf flex items-center ">
            <div class="img">

              <img alt='' src="/icons/tpAgent.png" style={{ width: 150, objectFit: 'contain', marginRight: 30 }} />

            </div>
            <div class="img">
              <img src="/icons/tpClient.png" alt="" style={{ width: 180, objectFit: 'contain' }} />
              {/* <!--<span>TP Client</span>--> */}
            </div>
          </div>
          <div class="higilights-pdf">
            <img alt="" src="/icons/sentiment2.png" style={{ width: 142, height: 143, objectFit: 'contain' }} />
          </div>
        </div>
        <div class="call-resume-container-pdf" >
          <div class="call-resume-loading-pdf">
            <h2>{t('common.conversation')}</h2>
          </div>
          <div style={{ paddingLeft: 20, paddingRight: 20 }}>
            <div id="sidebar-chat" class="call-resume-indicators-pdf" >
              {call?.sentiment.map((item, idex) => (
                <div class="call-resume-text-container-pdf"  >
                  {item.user !== '' &&
                    <div class="call-resume-text-pdf" style={{ paddingTop: 15, paddingBottom: 15 }}>
                      <div className='flex items-start justify-start'>
                        <img class="avatar_left-pdf" src="/icons/tpAgentMini.png" alt="" style={{ marginLeft: 12 }} />
                        <div className='flex flex-col items-start justify-start'>
                          <div class="text-left-pdf">{t('reports.sentiment')}: {item.polarity}</div>
                          <div class="text-left-pdf" style={{ color: '#575756', width: 500 }}>{item.user}</div>
                        </div>

                      </div>

                    </div>
                  }
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <p class="text-bot-pdf chat-bot-pdf" style={{ color: '#575756', width: 500 }}>{item?.bot}
                      <img class="avatar_right-pdf" src="/icons/tpClientMini.png" alt="" />
                    </p>
                  </div>
                </div>))}
            </div>
          </div>
        </div>

      </div>

      <div></div>

      {listproofread.length > 0 && (

          <div className="w-full text-[#0b5fa3] font-bold text-sm h-[calc(100vh-200px)] overflow-y-auto">
            {/* Header Section */}
            <div className="h-[30%] min-h-[200px] flex justify-between items-center px-10">
              <div className="w-[30%] flex flex-col items-center">
                <h4 className="text-center w-full mb-2">{t('common.score')}</h4>
                <span className="font-sans text-[#0b5fa3] text-[65px] font-bold">
                  {proofreadscore}%
                </span>
              </div>

              <div className="w-[50%] flex flex-wrap justify-center">
                <h4 className="w-full text-center text-[#575756]">
                  {t('reports.grammar.sectionDescription')}
                </h4>
              </div>

              <div className="text-center w-[20%] pt-[3%] flex flex-col items-end">
                <h4>{t('reports.highlights')}</h4>
                <img
                  src="/icons/sentiment2.png"
                  alt="Sentiment Analysis"
                  className="w-[142px] h-[143px] object-contain mt-2"
                />
              </div>
            </div>

            {/* Body Section */}
            <div className="border-2 border-gray-100 rounded-lg flex justify-evenly mx-5 mb-20">
              <div className="w-full flex flex-col">
                <h2 className="text-center py-4">{t('reports.grammar.greetingVerification')} {proofreadscore}%</h2>

                <div className="w-full max-h-[400px] overflow-auto 
            scrollbar-thin scrollbar-track-transparent scrollbar-thumb-blue-500 
            scrollbar-track-rounded-md scrollbar-thumb-rounded-md px-4">

                  {listproofread.map((item, index) => (
                    <div key={index} className="pb-2.5 border-b-2 border-[#b0b1b3] mb-4">
                      <div className="flex">
                        <div className="flex items-center">
                          <span className={`px-4 py-2 ml-2.5 ${getClass(item.score * 100)}`}>
                            {item.user}
                          </span>
                          <b className="text-xs px-2.5 text-black">
                            {t('reports.grammar.sentenceWithoutErrors')}
                          </b>
                        </div>
                      </div>
                      <div className="text-black mt-2 pl-4">
                        {item.correctPhrase}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
      )}

      {call !== null && 
        <CallStyles data={call} />
      }
      
      {call !== null && 
        <CallKPI data={call} />
      }

    </div>
  );
}